
  import { Component, Prop, Vue } from 'vue-property-decorator';

  @Component({
    components: {},
  })
  export default class LoginRow extends Vue {
    @Prop({ default: false }) readonly isInSideBar!: boolean;
  }
